import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { AuthService } from 'app/services/auth.service';
import { ProjectService } from 'app/services/models/project.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-project-detail',
  templateUrl: './project-detail.component.html',
  styleUrls: ['./project-detail.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProjectDetailComponent implements OnInit {
  public contentHeader: object;
  project: any = {};
  rows: any[] = [];

  files: any[];
  public selectedFiles: File[] = [];
  fileName: string = 'Dosya Seç'

  public ColumnMode = ColumnMode
  constructor(
    private activatedRouter: ActivatedRoute,
    private projectService: ProjectService,
    private router: Router,
    private toastrService: ToastrService,
    public authService:AuthService) { }

  ngOnInit(): void {
    this.contentHeader = {
      headerTitle: 'Proje',
      actionButton: true,
      breadcrumb: {
        type: '',
        links: [
          {
            name: 'Proje Listesi',
            isLink: true,
            link: '/project'
          },
          {
            name: 'Proje Detay',
            isLink: false,
          },
        ]
      }
    };
    this.activatedRouter.params.subscribe(async params => {
      await this.getByIdProject(params['id'])
    });
  }

  eventDelete() {
    this.router.navigate(['/admin/project']);
  }

  async getByIdProject(id) {
    const data = await this.projectService.getByIdProject(id);
    this.project = data;
    console.log(this.project);
    this.rows = this.project.projectTransactionManagement;
    const projectFileAuthorization = this.authService.isEndpointStatus('GET.Reading.GetProjectFile');
    if(projectFileAuthorization){
      await this.getByIdProjectFile(this.pageBasic - 1, this.selectedSize, this.project.id);
    }
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFiles = [input.files[0]];
      this.fileName = input.files[0].name;
    }
  }

  async createFile() {
    console.log(this.selectedFiles);
    console.log(this.project.id);
    const data = await this.projectService.createProjectFile(this.selectedFiles, this.project.id);
    console.log(data);
    if (data.status) {
      this.toastrService.success(data.message);
      this.getByIdProject(this.project.id);
    } else {
      this.toastrService.error(data.message);
    }
  }

  async getByIdProjectFile(page, size, id) {
    const data = await this.projectService.getByIdProjectFile(page, size, id);
    console.log(data);
    this.files = data.projectFile;
    this.totalCount = data.totalCount;
  }

  public pageBasic = 1;
  public selectedSize = 5;
  public basicSelectedOption = 5;
  totalCount: number = 0;

  async onPageChange() {
    await this.getByIdProjectFile(this.pageBasic - 1, this.selectedSize, this.project.id);

  }

  async onOptionChange() {
    this.selectedSize = Number(this.basicSelectedOption);
    await this.getByIdProjectFile(this.pageBasic - 1, this.selectedSize, this.project.id);
  }

  
  getFileExtension(fileName: string): string {
    // Dosya uzantısını almak için split kullanıyoruz
    return fileName?.split('.').pop() || 'Bilinmiyor';
}
}
